export default __webpack_public_path__ + "static/media/attach_file_icon.29fe8ec6.svg";